import { BASEURL } from "../BaseUrl";

/**
 * Fetches a list of log streams based on workflow type and ID.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {Object} data - The parameters for fetching log streams.
 * @param {string} data.workflow_type - The type of workflow to filter log streams by.
 * @param {string} data.workflow_id - The ID of the workflow to filter log streams by.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getAllLogstreams = async (axios, data) => {
  return await axios.get(`${BASEURL}/logs/all-logstreams`, {
    params: {
      workflow_type: data.workflow_type,
      workflow_id: data.workflow_id,
      pageNumber: data.pageNumber,
      pageSize: data.pageSize,
      status: data.status,
    },
  });
};

/**
 * Fetches log events for a specific log stream.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {Object} data - The parameters for fetching log events.
 * @param {string} data.workflow_type - The type of workflow associated with the log stream.
 * @param {string} data.log_stream_name - The name of the log stream to fetch events for.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getLogStreamEvent = async (axios, data) => {
  return await axios.get(`${BASEURL}/logs/get-logs-by-logstream`, {
    params: {
      workflow_type: data.workflow_type,
      log_stream_name: data.log_stream_name,
    },
  });
};

export const LogApi = {
  getAllLogstreams,
  getLogStreamEvent,
};
